import {datetimeFormatter} from '@hconnect/uikit'
import {Timeline, TimelineElementProps} from '@hm/fundamental'
import {Box, Divider, Grid} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {CustomHeader} from '../../../Molecules/CustomHeader'
import {Features} from '../../../Organisms/Features'
import {Order} from '../Order.types'

import {getOrderChangeText} from './OrderDetails.utils'

interface OrderHistoryDetailsProps {
  order: Order
}


export const OrderHistoryDetails: React.FC<OrderHistoryDetailsProps> = ({order}) => {
  const {
    t,
    i18n: {language}
  } = useTranslation()
  
  if (!order || !order.orderChanges?.length) return null

  const orderChanges = order.orderChanges.sort((a, b) =>
    (b.changeDate || '') > (a.changeDate || '') ? -1 : 1
  )
  const {quantityUom} = order?.lineItems[0] || {}

  const timelineItems: TimelineElementProps[] = orderChanges.map((oc, index) => ({
    time: datetimeFormatter(oc.changeDate || '', language),
    title: getOrderChangeText(oc, quantityUom, t, language),
    position: index === 0 ? 'Start' : index === orderChanges.length - 1 ? 'End' : 'Middle',
    'data-cy': `order-change-${oc.changeNumber}`
  }))

  // Handle single item case
  if (timelineItems.length === 1) {
    timelineItems[0].position = 'Single step'
  }

  return (
    <Features name="OrderChangeTrail">
      <Grid container data-test-id="order-change-trail">
        <Grid item xs={12}>
          <Box my={2}>
            <Divider />
          </Box>
          <CustomHeader title="Order History Details" noDivider />
          <Timeline items={timelineItems} />
        </Grid>
      </Grid>
    </Features>
  )
}
